import React, { useState, useEffect } from "react"
import { AppBar, Tabs, Tab, Box, Badge } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { connect, useSelector } from "react-redux"
import { useHistory } from "react-router-dom"
import jwtDecode from "jwt-decode"

const TabBar = ({ classes, currentOrg }) => {
  const [value, setValue] = useState(0)
  const authentication = useSelector(state => state.authentication)
  const organization = useSelector(state => state.organization.currentOrg)
  const [isSuperUser, setIsSuperUser] = useState(false)

  let history = useHistory()

  useEffect(() => {
    try {
      const token = authentication.token
      const isSuperUser = jwtDecode(token).su
      setIsSuperUser(Boolean(isSuperUser))
    } catch (err) {
      console.log(err)
    }
  }, [authentication])

  function handleClick(route) {
    history.push(`/admin/${route}`)
  }

  const handleChange = (e, newValue) => {
    setValue(newValue)
  }
  const isAdmin = currentOrg.role_id < 3

  useEffect(() => {
    const path = window.location.pathname
    let index
    switch (path) {
      case "/admin/recentposts":
        index = 0
        break
      case "/admin/organizations":
        index = 1
        break
      case "/admin/members":
        index = 2
        break
      case "/admin/settings":
        index = 3
        break
      case "/admin/communication":
        index = 4
        break
    }
    if (!isAdmin && index > 0) {
      index = 0
    }
    setValue(index)
  }, [window.location.pathname, isAdmin])

  const requestedOrgs =
    organization &&
    organization.partners &&
    organization.partners.filter(
      x => x.accepted === 0 && Number(x.org_id) !== Number(organization.id)
    )
  return (
    <div className={classes.tavbarContainer}>
      <AppBar
        position="static"
        color="default"
        elevation={0}
        className={classes.appBarContainer}
      >
        <Box display="flex" flexWrap="wrap">
          <Box flexGrow={1}>
            <Tabs
              className={classes.tabsContainer}
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                className={classes.appBarText}
                label="Recent Posts"
                onClick={() => handleClick("recentposts")}
              />
              {isAdmin && [
                <Tab
                  className={classes.appBarText}
                  label={
                    <Badge
                      invisible={!requestedOrgs || requestedOrgs.length === 0}
                      badgeContent={requestedOrgs && requestedOrgs.length}
                    >
                      organizations
                    </Badge>
                  }
                  onClick={() => handleClick("organizations")}
                  key={1}
                />,
                <Tab
                  className={classes.appBarText}
                  label="Members"
                  onClick={() => handleClick("members")}
                  key={2}
                />,
                <Tab
                  className={classes.appBarText}
                  label="Settings"
                  onClick={() => handleClick("settings")}
                  key={3}
                />,
                <Tab
                  className={classes.appBarText}
                  label="Communication"
                  onClick={() => handleClick("communication")}
                  key={4}
                />
              ]}
            </Tabs>
          </Box>
        </Box>
      </AppBar>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    currentOrg: state.organization.currentOrg
  }
}

const connector = connect(mapStateToProps)

export default connector(withStyles(styles)(TabBar))



// WEBPACK FOOTER //
// ./src/components/TabBar/index.jsx